import _ from 'lodash'
import { FormattedMessage } from 'react-intl';

import 'draft-js/dist/Draft.css';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { TextSnippetIcon, TextSnippetOutlinedIcon } from '../../constants/images';

import theme from '../../theme';

import BasicDataLanguage from './BasicDataLanguage';
import GoogleConversionData from './google/GoogleConversionData';


const BasicData = (props) => {
  const {
    media,
    reportLanguage,
    setReportLanguage,
    conversionsType,
    setConversionsType,
    setCurrentSheetName,
    setCurrentSheetOrigiName,
    setSelectedExcelIndex,
    setSelectedConversionsFields,
    tickAllConversionsData,
    tickConversionsData,
    conversionsData,
  } = props;

  return (
    <Box mb={5}>
      <Typography
        sx={{
          ...theme.typography.h4_normal,
          mb: 2,
          color: theme.palette.grey.w700,
        }}
      >
        <TextSnippetOutlinedIcon
          sx={{
            mr: 0.5,
            verticalAlign: 'sub'
          }}
        />
        <FormattedMessage id="createData.header.basicReport" />
      </Typography>

      {(media === 'GOOGLE' || media === 'FACEBOOK') &&
        <BasicDataLanguage
          media={media}
          reportLanguage={reportLanguage}
          setReportLanguage={setReportLanguage}
          setCurrentSheetName={setCurrentSheetName}
          setCurrentSheetOrigiName={setCurrentSheetOrigiName}
          setSelectedExcelIndex={setSelectedExcelIndex}
        />
      }

      {media === 'GOOGLE' &&
        <GoogleConversionData
          conversionsType={conversionsType}
          setConversionsType={setConversionsType}
          setCurrentSheetName={setCurrentSheetName}
          setSelectedExcelIndex={setSelectedExcelIndex}
          setSelectedConversionsFields={setSelectedConversionsFields}
          tickAllConversionsData={tickAllConversionsData}
          tickConversionsData={tickConversionsData}
          conversionsData={conversionsData}
        />
      }
    </Box>
  )
}

export default BasicData;